import { buildApiUrl } from '../../services/apiConfig';

class AnalyzeDataService {
  async request(endpoint, options = {}) {
    const token = localStorage.getItem('auth_token') || 'dev-token';
    const response = await fetch(buildApiUrl('NOVA_INGESTION', endpoint), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
      ...options,
    });
    if (!response.ok) {
      throw new Error(`API error ${response.status}: ${await response.text()}`);
    }
    if (response.status === 204 || response.headers.get('content-length') === '0') {                         
     return null;                                                                                           
    }
    return response.json();
  }

  async getSources() {
    // return this.request('/sources');
    const response = await fetch(buildApiUrl("NOVA_INGESTION", '/sources'));
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }


  async deleteSource(sourceId) {
    return this.request(`/sources/${sourceId}`, { method: 'DELETE' });
  }

  async getSource(sourceId) {
    return this.request(`/sources/${sourceId}`);
  }
}

export default new AnalyzeDataService();
